
<template>
   <div>
    <vehicle-bike-car />
   </div>
</template>

<script>
import VehicleBikeCar from './VehicleBikeCar'

export default {
  name: "Vehicle",
  data() {
    return {

    }
  },
  watch: {
  },
  computed: {
    
  },
  methods: {
    
  },
  components: {
    "vehicle-bike-car": VehicleBikeCar,
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Apartment/Vehicle.vue